import { keyBy } from "lodash";

import { Row } from "../../../../types";

export const enhancePrevRows = (prevRows: Row[], newRows: Row[]): Row[] => {
  const newRowsByKey = keyBy(newRows, "key");
  return prevRows.map((row) => ({
    ...row,
    ...(newRowsByKey[row.key] || {})
  }));
};
